export default __webpack_public_path__ + "static/media/trus9.d9da8196.png";